<template>
  <div class="aboutPage">
    <div class="aBox1">
      <img
        class="ab1Img"
        src="http://cdn.xiyundata.com/crane_index/version3/v3about01.png"
        alt=""
      />
      <img
        class="ab1Img2"
        src="http://cdn.xiyundata.com/crane_index/version3/v3about02m.png"
        alt=""
      />
    </div>
    <div class="aBox2">
      <div class="aBox2Content">
        <div class="ab2mTop">
          <div class="ab2Num">
            <div class="numTop">50000+</div>
            <div class="numBom">50000台设备在线运行</div>
          </div>
          <div class="ab2Num">
            <div class="numTop">1000+</div>
            <div class="numBom">1000多家合作客户</div>
          </div>
        </div>
        <div class="ab2mTop">
          <div class="ab2Num">
            <div class="numTop">100+</div>
            <div class="numBom">全国100多个试点</div>
          </div>
          <div class="ab2Num">
            <div class="numTop">1000+</div>
            <div class="numBom">15年的行业经验</div>
          </div>
        </div>
      </div>
    </div>
    <div class="introduceBox">
      <div class="introContent">
        <div class="ibLeft">
          <div class="ibl1">企业介绍</div>
          <div class="ibl2">CORPORATE CULTURE</div>
        </div>
        <div class="ibRight">
          <div class="ibrTop">
            我们始终坚信，“人”是数港物联技术探索的出发点，也是起重机应力监测科研应用实践的归宿。我们始终坚信，技术能在确保实效的基础上，融入更多人性关怀与温暖。数港物联，凭借人性化的智能技术深入各类应用场景，激发多产业领域的无限潜能。
          </div>
          <div class="ibrBom">
              <img class="iImg" src="http://cdn.xiyundata.com/crane_index/version3/v3about03.png" alt="" style="margin-right: 2px;">
              <img class="iImg" src="http://cdn.xiyundata.com/crane_index/version3/v3about05.png" alt="" style="margin-right: 2px;">
              <img class="iImg" src="http://cdn.xiyundata.com/crane_index/version3/v3about07.png" alt="">
          </div>
          <div class="ibrBom2">
              <img class="iImg2" src="http://cdn.xiyundata.com/crane_index/version3/v3about04.png" alt="" style="margin-right: 2px;">
              <img class="iImg2" src="http://cdn.xiyundata.com/crane_index/version3/v3about06.png" alt="" style="margin-right: 2px;">
              <img class="iImg2" src="http://cdn.xiyundata.com/crane_index/version3/v3about08.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="aBox3">
      <div class="aBox3Content">
        <div class="ab3Line2">创新驱动，技术引领</div>
        <div class="ab3Line3">
          我们坚持技术创新，不断探索物联网、大数据、人工智能等前沿技术在设备安全监测中的应用，以科技的力量提升设备安全管理水平，为客户提供更高效、更智能的解决方案。
        </div>
      </div>
    </div>
    <div class="aBox4">
      <div class="aBox4Content">
        <img
          class="ab4Img"
          src="http://cdn.xiyundata.com/crane_index/version3/v3about09.png"
          alt=""
        />
        <img
          class="ab4Img2"
          src="http://cdn.xiyundata.com/crane_index/version3/v3about10.png"
          alt=""
        />
      </div>
    </div>
    <div class="aBox6">
      <div class="aBox6Content">
        <div class="ab6Line2">以创新为引擎，以技术为基石</div>
        <div class="ab6Line3">
          通过构建智能化的设备健康监测体系，实现故障预测精度提升与运维效率突破，为客户打造集实时感知、智能诊断与主动防护于一体的智慧化解决方案。
        </div>
      </div>
    </div>
    <div class="aBox8">
      <div class="aBox8Content">
        <img
          class="ab8Img"
          src="http://cdn.xiyundata.com/crane_index/version3/v3about13.png"
          alt=""
        />
        <img
          class="ab8Img2"
          src="http://cdn.xiyundata.com/crane_index/version3/v3about14.png"
          alt=""
        />
      </div>
    </div>
    <!-- <div class="aBox7">
      <div class="aBox7Content">
        <div class="a7Line1">Latest News</div>
        <div class="a7Line2">最新资讯</div>
        <div class="a7Line3">
          <div class="a7Line3Item">
            <img
              class="a7Line3ItemImg"
              src="https://www.westwell-lab.com/uploads/attachments/post-357a6fdf7642bf815a88822c447d9dc4/%E5%AE%98%E7%BD%91banner_CN.jpg"
              alt=""
            />
            <div class="a7Line3ItemContent">
              <div class="a7Info1">数港物发布全新客户服务品牌<br>WeWell Service 数智赋能Ainergy...</div>
              <div class="a7Info2">2024-09-09</div>
              <div class="a7Info3">全生命周期智慧服务，...</div>
            </div>
          </div>
          <div class="a7Line3Item">
            <img
              class="a7Line3ItemImg"
              src="https://www.westwell-lab.com/uploads/attachments/post-310dcbbf4cce62f762a2aaa148d556bd/%E5%AE%98%E7%BD%91Banner.jpg"
              alt=""
            />
            <div class="a7Line3ItemContent">
              <div class="a7Info1">数港物发布全新客户服务品牌<br>WeWell Service 数智赋能Ainergy...</div>
              <div class="a7Info2">2024-09-09</div>
              <div class="a7Info3">全生命周期智慧服务，...</div>
            </div>
          </div>
          <div class="a7Line3Item">
            <img
              class="a7Line3ItemImg"
              src="https://www.westwell-lab.com/uploads/attachments/post-758874998f5bd0c393da094e1967a72b/39X294.jpg"
              alt=""
            />
            <div class="a7Line3ItemContent">
              <div class="a7Info1">数港物联发布全新客户服务品牌<br>WeWell Service 数智赋能Ainergy...</div>
              <div class="a7Info2">2024-09-09</div>
              <div class="a7Info3">全生命周期智慧服务，...</div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script >
export default {
  data() {
    return {
      swiperIndex: 0,
    };
  },
  methods: {
    handleScroll() {
      // 图片淡入动画
      const ab4Img = this.$el.querySelector(".ab4Img");
      const ab4ImgTop = ab4Img.offsetTop;
      const windowHeight = window.innerHeight;
      const scrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;

      if (
        scrollPosition + windowHeight > ab4ImgTop &&
        scrollPosition < ab4ImgTop + ab4Img.offsetHeight
      ) {
        ab4Img.classList.add("fade-in-animation");
      } else {
        ab4Img.classList.remove("fade-in-animation");
      }

      const ab4Img2 = this.$el.querySelector(".ab4Img2");
      const ab4ImgTop2 = ab4Img2.offsetTop;
      if (
        scrollPosition + windowHeight > ab4ImgTop2 &&
        scrollPosition < ab4ImgTop2 + ab4Img2.offsetHeight
      ) {
        ab4Img2.classList.add("fade-in-animation");
      } else {
        ab4Img2.classList.remove("fade-in-animation");
      }

      // 轮播图淡入动画
      // const aBox5 = this.$el.querySelector(".aBox5");
      // const aBox5Top = aBox5.offsetTop;
      // if (
      //   scrollPosition + windowHeight > aBox5Top &&
      //   scrollPosition < aBox5Top + aBox5.offsetHeight
      // ) {
      //   aBox5.classList.add("fade-in-animation");
      // } else {
      //   aBox5.classList.remove("fade-in-animation");
      // }

      const aBox6Content = this.$el.querySelector(".aBox6Content");
      const aBox6ContentTop = aBox6Content.offsetTop;
      if (
        scrollPosition + windowHeight > aBox6ContentTop &&
        scrollPosition < aBox6ContentTop + aBox6Content.offsetHeight
      ) {
        aBox6Content.classList.add("fade-in-animation2");
      } else {
        aBox6Content.classList.remove("fade-in-animation2");
      }

      const ab8Img = this.$el.querySelector(".ab8Img");
      const ab8ImgTop = ab8Img.offsetTop;
      if (
        scrollPosition + windowHeight > ab8ImgTop &&
        scrollPosition < ab8ImgTop + ab8Img.offsetHeight
      ) {
        ab8Img.classList.add("fade-in-animation");
      } else {
        ab8Img.classList.remove("fade-in-animation");
      }

      const ab8Img2 = this.$el.querySelector(".ab8Img2");
      const ab8ImgTop2 = ab8Img2.offsetTop;
      if (
        scrollPosition + windowHeight > ab8ImgTop2 &&
        scrollPosition < ab8ImgTop2 + ab8Img2.offsetHeight
      ) {
        ab8Img2.classList.add("fade-in-animation");
      } else {
        ab8Img2.classList.remove("fade-in-animation");
      }
      // const aBox7 = this.$el.querySelector(".aBox7");
      // const aBox7Top = aBox7.offsetTop;
      // if (
      //   scrollPosition + windowHeight > aBox7Top &&
      //   scrollPosition < aBox7Top + aBox7.offsetHeight
      // ) {
      //   aBox7.classList.add("fade-in-animation");
      // } else {
      //   aBox7.classList.remove("fade-in-animation");
      // }
    },
    ecChange(e) {
      this.swiperIndex = e;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.aboutPage {
  /* padding-top: 70px; */
}
.aBox1 {
  width: 100vw;
}
.ab1Img {
  width: 100%;
  position: relative;
  z-index: -100;
}
.ab1Img2 {
  width: 100%;
}
.aBox2 {
  /* background-color: pink; */
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 182px;
}
.aBox2Content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1225px;
  height: 100%;
  /* padding-top: 50px; */
  border-bottom: 1px solid #D8D8D8;
}
.ab2mTop {
  width: 42%;
  display: flex;
  justify-content: space-between;
}
.ab2Num {

}
.numTop {
  font-weight: 700;
  font-size: 45px;
  color: #DA0010;
  line-height: 65px;
}
.numBom {
  font-weight: 400;
  font-size: 14px;
  color: #9E9E9E;
}
.ab2Top {
  font-size: 34px;
  font-weight: bold;
  color: #262626;
  line-height: 1.4;
}
.ab2Title {
  font-size: 30px;
  color: #262626;
  line-height: 1.3;
}
.ab2Content {
  line-height: 30px;
  margin-top: 20px;
  font-size: 16px;
  color: #262626;
  text-align: center;
}
.introduceBox {
  width: 100vw;
  height: 632px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 80px;
  box-sizing: border-box;
  margin-bottom: 174px;
}
.introContent {
  width: 1200px;
  height: 100%;
  display: flex;
  justify-content: space-between;
}
.ibLeft {
  width: 600px;
}
.ibl1 {
  font-weight: 700;
  font-size: 30px;
  color: #33333A;
  line-height: 43px;
}
.ibl2 {
  font-weight: 400;
  font-size: 14px;
  color: #99999A;
  line-height: 20px;
}
.ibRight {
  padding-top: 10px;
}
.ibrTop {
  width: 100%;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 21px;
  margin-bottom: 50px;
}
.ibrBom {
  width: 904px;
  height: 450px;
  display: flex;
}
.iImg {
  width: 300px;
  height: 450px;
}
.aBox3 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 110px;
}
.aBox3Content {
  width: 1200px;
  height: 100%;
}
.ab3Line1 {
  color: #262626;
  line-height: 1.4;
  font-size: 46px;
  letter-spacing: 2px; /* 增加字间距 */
}
.ab3Line1 .txt {
  margin-left: 25px;
  background-image: linear-gradient(40deg, #09addb 30%, #0fbda9);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-size: 46px; /* 根据需要调整字体大小 */
  font-weight: bold; /* 根据需要调整字体粗细 */
  line-height: 1.4;
  transition: opacity 0.5s ease-in-out; /* 定义透明度的过渡效果 */
}
.ab3Line2 {
  font-size: 30px;
  color: #33333A;
}
.ab3Line3 {
  margin-top: 20px;
  font-size: 14px;
  color: #666666;
}
.aBox4 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 515px;
  margin-bottom: 176px;
}
.aBox4Content {
  width: 1200px;
  height: 100%;
}
.ab4Img {
  width: 100%;
}
.aBox5 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 726px;
}

.fade-in-animation {
  animation: fade-in 1s ease-in-out forwards;
}

.fade-in-animation2 {
  animation: fade-in 2s ease-in-out forwards;
}

.ec {
  width: 100%;
  height: 100%;
}
.ecItem1 {
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("https://www.westwell-lab.com/img/about/info-block-1.png");
}
.ecItem2 {
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("https://www.westwell-lab.com/img/about/info-block-2.png");
}
.ecItem3 {
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("https://www.westwell-lab.com/img/about/info-block-3.png");
}
.ecItemInner {
  display: flex;
  justify-content: space-between;
  height: 486px;
  width: 1200px;
}
.ecLeft {
  height: 100%;
  /* width: 60%; */
}
.ecRight {
  height: 100%;
  /* width: 40%; */
}
.ecRightImg {
  width: 486px;
}
.ecLine1 {
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  animation: slide-up-fade-in 1s ease-in-out forwards; /* 应用动画 */
}
b {
  background: #0fbda8;
  display: inline-block;
  height: 20px;
  margin: 0 15px;
  width: 2px;
}
.ecLine2 {
  margin-top: 26px;
  color: #fff;
  font-size: 20px;
  line-height: 1.6;
  font-weight: 300;
  animation: slide-up-fade-in 1s ease-in-out forwards; /* 应用动画 */
}
.ecLine3 {
  margin-top: 60px;
  font-size: 26px;
  font-weight: 300;
  line-height: 1.7;
  color: #fff;
  animation: slide-up-fade-in 1s ease-in-out forwards; /* 应用动画 */
}
.ecLine4 {
  border: 1px solid #ffffff;
  border-radius: 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  width: 174px;
  height: 55px;
  font-size: 18px;
  margin-top: 50px;
  animation: slide-up-fade-in 1s ease-in-out forwards; /* 应用动画 */
}
.ecLine4:hover {
  background-image: linear-gradient(to right, #09addb, #0ebaaf);
  border: 1px solid transparent;
}
.aBox6 {
  display: flex;
  justify-content: center;
  /* align-items: center; */
  width: 100vw;
  height: 109px;
}
.aBox6Content {
  width: 1200px;
}
.ab6Line1 {
  color: #262626;
  line-height: 1.4;
  font-size: 46px;
  letter-spacing: 2px; /* 增加字间距 */
  text-align: right;
}
.ab6Line1 .txt {
  margin-left: 25px;
  background-image: linear-gradient(40deg, #09addb 30%, #0fbda9);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-size: 46px; /* 根据需要调整字体大小 */
  font-weight: bold; /* 根据需要调整字体粗细 */
  line-height: 1.4;
  transition: opacity 0.5s ease-in-out; /* 定义透明度的过渡效果 */
}
.ab6Line2 {
  font-size: 30px;
  color: #33333A;
  text-align: right;
}
.ab6Line3 {
  width: 100%;
  text-align: right;
  margin-top: 20px;
  font-size: 14px;
  color: #666666;
}
.aBox7 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 420px;
  margin-bottom: 138px;
}
.aBox7Content {
  width: 1200px;
  height: 100%;
}
.a7Line1 {
  font-size: 45px;
  color: #262626;
  font-weight: bold;
  line-height: 1.4;
}
.a7Line2 {
  margin-top: 2px;
  font-size: 34px;
  font-weight: 300;
}
.a7Line3 {
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}
.a7Line3Item {
  position: relative; /* 设置相对定位 */
  width: 385px;
  height: 289px;
  overflow: hidden; /* 防止伪元素超出时显示滚动条 */
}
.a7Line3ItemImg {
  vertical-align: middle;
  width: 385px;
}
.a7Line3Item::after {
  content: ''; /* 伪元素内容为空 */
  position: absolute; /* 绝对定位 */
  top: 100%; /* 初始位置在元素底部之外 */
  left: 0;
  width: 100%; /* 宽度铺满整个元素 */
  height: 100%; /* 高度铺满整个元素 */
  background-color: white; /* 白色背景 */
  transition: top 0.2s ease-in-out, opacity 0.5s ease-in-out; /* 平滑过渡 */
  opacity: 0; /* 初始透明度为0 */
  z-index: 1; /* 确保伪元素在图片之上 */
}

.a7Line3Item:hover::after {
  top: 0; /* 鼠标悬浮时移动到元素顶部 */
  opacity: 1; /* 鼠标悬浮时透明度变为1 */
}
.a7Line3ItemContent {
  position: absolute; /* 绝对定位 */
  top: 100%; /* 初始位置在元素底部之外 */
  left: 0;
  width: 100%; /* 宽度铺满整个元素 */
  height: 100%; /* 高度铺满整个元素 */
  display: flex; /* 使用 flex 布局 */
  flex-direction: column;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  transition: top 0.2s ease-in-out; /* 平滑过渡 */
  z-index: 2; /* 确保内容在白色框之上 */
  border: 2px solid transparent; /* 设置边框大小和颜色 */
  border-image: linear-gradient(to bottom, #09addb, #0fbbb0) 1 / 1 / 0 stretch; /* 设置渐变色 */
}

.a7Line3Item:hover .a7Line3ItemContent {
  top: 0; /* 鼠标悬浮时移动到元素顶部 */
}
.a7Info1 {
  width: 300px;
  line-height: 1.5;
  color: #262626;
  font-size: 18px;
  overflow: hidden; /* 隐藏溢出的内容 */
  margin-bottom: 5px;
}
.a7Info2 {
  width: 300px;
  line-height: 1.5;
  font-size: 16px;
  text-align-last: left;
  color: #9e9e9e;
  font-weight: 300;
  margin-bottom: 17px;
}
.a7Info3 {
  width: 300px;
  line-height: 1.5;
  font-size: 18px;
  text-align-last: left;
  padding-bottom: 17px;
}
.aBox8 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 515px;
  margin-bottom: 86px;
}
.aBox8Content {
  width: 1200px;
  height: 100%;
  overflow: hidden;
}
.ab8Img {
  width: 100%;
}

/* 淡入动画 */
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* 定义上移并淡入的关键帧动画 */
@keyframes slide-up-fade-in {
  from {
    transform: translateY(20px); /* 从当前位置向下移动20px */
    opacity: 0; /* 完全透明 */
  }
  to {
    transform: translateY(0); /* 回到原始位置 */
    opacity: 1; /* 完全不透明 */
  }
}

/* 媒体查询，屏幕宽度小于830px */
@media (max-width: 830px) {
  .ab1Img {
    display: none;
  }
  .ab1Img2 {
    display: block;
  }
  .aBox2 {
    height: auto;
  }
  .aBox2Content {
    padding-top: 50px;
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 0px;
    display: block;
    border-bottom: none;
  }
  .ab2mTop {
    padding: 0 20px;
    width: 98%;
    height: 120px;
    border-bottom: 1px solid #D8D8D8;
    margin-bottom: 20px;
  }
  .ab2mTop:last-child {
    border-bottom: none;
  }
  .ab2Top {
    font-size: 23px;
  }
  .ab2Title {
    font-size: 23px;
  }
  .ab2Content {
    font-size: 12px;
  }
  .aBox3 {
    height: 218px;
  }
  .aBox3Content {
    padding-left: 37px;
    padding-right: 37px;
  }
  .ab3Line1 {
    font-size: 36px;
  }
  .ab3Line1 .txt {
    font-size: 36px;
  }
  .ab3Line2 {
    font-weight: 700;
    font-size: 26px;
    color: #33333A;
  }
  .ab3Line3 {
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 36px;
    margin-top: 30px;
  }
  .aBox4 {
    height: fit-content;
    margin-bottom: 55px;
  }
  .aBox6 {
    height: 218px;
  }
  .aBox6Content {
    padding-left: 45px;
    padding-right: 45px;
  }
  .ab6Line1 {
    font-size: 36px;
  }
  .ab6Line1 .txt {
    font-size: 36px;
  }
  .ab6Line2 {
    font-size: 26px;
    font-weight: 700;
    color: #33333A;
  }
  .ab6Line3 {
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 36px;
    margin-top: 30px;
  }
  .aBox8 {
    height: fit-content;
    margin-bottom: 55px;
  }
  .introContent {
    display: block;
  }
  .introContent {
    width: 100%;
    padding: 0 37px;
  }
  .introduceBox {
    padding-top: 25px;
    height: auto;
    margin-bottom: 55px;
  }
  .ibLeft {
    width: 100%;
  }
  .ibl1 {
    text-align: center;
  }
  .ibl2 {
    text-align: center;
  }
  .ibrTop {
    text-align: center;
    margin-bottom: 30px;
    line-height: 36px;
  }
  .ibrBom {
    display: none;
  }
  .ibrBom2 {
    width: 100%;
    height: auto;
  }
  .iImg2 {
    width: 100%;
    height: auto;
  }
  .ab4Img {
    display: none;
  }
  .ab4Img2 {
    display: block;
    width: 100%;
  }
  .ab8Img {
    display: none;
  }
  .ab8Img2 {
    display: block;
    width: 100%;
  }
}

@media (min-width: 830px) {
  .ab1Img {
    display: block;
  }
  .ab1Img2 {
    display: none;
  }
  .ibrBom2 {
    display: none;
  }
  .ab4Img2 {
    display: none;
  }
  .ab4Img {
    display: block;
  }
  .ab8Img {
    display: block;
  }
  .ab8Img2 {
    display: none;
  }
}
</style>
